'use client'
import {createContext, useState, useContext, useEffect} from "react";
import {getCookie} from "cookies-next";
import {usePathname, useRouter} from "next/navigation";
import axiosInterceptorInstance from "@/axiosInterceptorInstance";


const AppContext = createContext();

export function AppWrapper({children}) {
    const [user, setUser] = useState();
    const [isSeeker, setIsSeeker] = useState(false);
    const [isMediator, setIsMediator] = useState(false);
    const [notifications, setNotifications] = useState();
    const [meetingNotificationsNumber, setMeetingNotificationsNumber] = useState(0)
    const [loading, setLoading] = useState(true);
    const pathname = usePathname();


    const getUser = async () => {
        setLoading(true);
        try {
            const res = await axiosInterceptorInstance(`${process.env.NEXT_PUBLIC_API_URL}/user`, {
                method: 'GET', headers: {
                    'Authorization': `Bearer ${getCookie('jwt')}`
                }
            })
            setUser(res.data.data);
            setNotifications(res.data.data.unread_messages_count);
            setMeetingNotificationsNumber(res.data.data.unread_notifications_count);
            setLoading(false)
        } catch (err) {
            if (err?.response?.status === 401) {
            } else {
                // error('errors.serverError'));
                // router.push('/login');
            }
        }
        setLoading(false);
    }

    useEffect(() => {
        if (pathname !== '/login' && pathname !== '/register' && pathname !== '/auth/google' && pathname !== '/verify/email') {
            if (getCookie('jwt')) {
                getUser();
            } else {
                setLoading(false);
            }
        }
    }, [])

    useEffect(() => {
        if (user?.roles?.some(role => role.name === 'Seeker' && role.is_active)) {
            setIsSeeker(true);
        } else {
            setIsSeeker(false);
        }
    }, [user]);

    useEffect(() => {
        if (user?.roles?.some(role => role.name === 'Mediator' && role.is_active)) {
            setIsMediator(true);
        } else {
            setIsMediator(false);
        }
    }, [user]);

    return (<AppContext.Provider
        value={{
            user,
            isSeeker,
            isMediator,
            setUser,
            loading,
            getUser,
            notifications,
            setNotifications,
            meetingNotificationsNumber,
            setMeetingNotificationsNumber
        }}>
        {children}
    </AppContext.Provider>)
}

export function useAppContext() {
    return useContext(AppContext);
}